module.exports = __webpack_public_path__ + "img/logo_1880.d559150.png";